import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import AttendanceRegisterPage from './pages/AttendanceRegisterPage';
import MyAttendancePage from './pages/MyAttendancePage';
import MySalaryPage from './pages/MySalaryPage';
import PayrollPage from './pages/PayrollPage';
import HolidaysPage from './pages/HolidaysPage';
import PayProfilesPage from './pages/PayProfilesPage';
import PayrollSetupPage from './pages/PayrollSetupPage';

/** Payroll & daily attendance (V28). */
export const payrollRoutes = [
  {
    path: '/my-attendance',
    element: <MyAttendancePage />,
    handle: { breadcrumb: 'My Attendance' },
    loader: requireModule(MODULES.MY_ATTENDANCE),
  },
  {
    path: '/my-salary',
    element: <MySalaryPage />,
    handle: { breadcrumb: 'My Salary' },
    loader: requireModule(MODULES.MY_SALARY),
  },
  {
    path: '/attendance-register',
    element: <AttendanceRegisterPage />,
    handle: { breadcrumb: 'Attendance Register' },
    loader: requireModule(MODULES.ATTENDANCE_REGISTER),
  },
  {
    path: '/payroll',
    element: <PayrollPage />,
    handle: { breadcrumb: 'Salary Processing' },
    loader: requireModule(MODULES.PAYROLL),
  },
  {
    path: '/payroll-setup',
    element: <PayrollSetupPage />,
    handle: { breadcrumb: 'Payroll Rules' },
    loader: requireModule(MODULES.PAYROLL_SETUP),
  },
  {
    path: '/pay-profiles',
    element: <PayProfilesPage />,
    handle: { breadcrumb: 'Pay Profiles' },
    loader: requireModule(MODULES.PAY_PROFILES),
  },
  {
    path: '/holidays',
    element: <HolidaysPage />,
    handle: { breadcrumb: 'Holidays' },
    loader: requireModule(MODULES.HOLIDAYS),
  },
];
